import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import { formataUrlBase, validaSite } from '@/shared/common/functions/roteamento'
import { validaAutenticacao } from '@/shared/common/functions/autenticacao'
import { aplicaVersaoAppDaUrl, aplicaVersaoAppPendente } from '@/shared/common/functions/ambiente'
import { insereNovidades } from '@/shared/plugins/novidades'
import loading from '@/shared/plugins/loading'

Vue.use(VueRouter)
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to) {
        if(to.meta && to.meta.disableScrollTop){
            return false
        }
        document.getElementById('app').scrollIntoView({
            behavior: "smooth"
        });
    }
})

// Troca de ambiente via ?versao_app= — roda aqui (e não no main.js) porque o
// router compartilhado é carregado por todos os builds, inclusive os módulos
aplicaVersaoAppDaUrl()

router.beforeEach(async (to, from, next) => {

    if (aplicaVersaoAppPendente(router.resolve(to.fullPath).href)) {
        return
    }

    insereNovidades(to.path)
    formataUrlBase(to.fullPath)

    if (to.path === '/') {
        loading.show()
        const possuiSite = await validaSite()
        if (possuiSite) {
            return window.location.href = '/site'
        } else {
            const isAutenticado = await validaAutenticacao()
            if (!isAutenticado) {
                return window.location.href = '/login'
            }else{
                return window.location.href = '/inicio'
            }
        }
    }

    if (!to.meta.public) {
        loading.show()
        const isAutenticado = await validaAutenticacao()
        if (!isAutenticado) {
            return window.location.href = Vue.prototype.$urlBase + '/login'
        }
        loading.hide()
    }

    next()
})

export default router
